import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NProductViewLayout } from '../../product.decorator';
import { ProductViewDimensionsAndDetailsComponent } from '../product-view-dimensions-and-details.component';
export const DIMENSIONS_MODAL_ID = 'dimensionsAndDetailsModal';
@DfModal({
    id: DIMENSIONS_MODAL_ID,
    position: 'bottom',
    config: () => ({
        width: '100%',
        height: '80vh',
        maxWidth: '100vw',
        modalClass: 'bg-col-w p-a-4',
        position: { bottom: '0' },
        closeOnNavigation: true
    }),
    blockGroup: 'modals',
    priority: 10,
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M']
})
@Component({
    selector: 'product-view-dimensions-and-details-modal',
    templateUrl: './product-view-dimensions-and-details-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ProductViewDimensionsAndDetailsComponent, TranslationModule]
})
export class ProductViewDimensionsAndDetailsModalComponent {
    constructor(
    @Optional()
    private modalRef: ModalRef<ProductViewDimensionsAndDetailsModalComponent>,
    @Optional()
    @Inject(MODAL_DATA)
    public content: NProductViewLayout.IBlockDataContent) { }
    /**
     * Close notification
     */
    close() {
        this.modalRef.close();
    }
}
